module.exports = __webpack_public_path__ + "static/media/Flyer2.b4573340.png";